// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Agenda_AlterarCompromissoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Agenda_AlterarCompromissoResponseDados = boolean;

export type Agenda_AlterarCompromissoResponse = ApiResponse<Agenda_AlterarCompromissoResponseDados>;

registerResponseContract('Agenda_AlterarCompromissoResponse', {})
